import React from 'react';
import PropTypes from 'prop-types';
import ContactSupportModal from '../../molecules/ContactSupportModal';
import Header from '../../molecules/Header';
import TitleBanner from '../../molecules/TitleBanner';

const PageTemplate = ({ title, subTitle }) =>
  (
    <React.Fragment>
      <ContactSupportModal />
      <Header />
      <TitleBanner title={title} subTitle={subTitle} />
    </React.Fragment>
  );


PageTemplate.propTypes = {
  title: PropTypes.node.isRequired,
  subTitle: PropTypes.string,
};

PageTemplate.defaultProps = {
  subTitle: '',
};

export default PageTemplate;



// WEBPACK FOOTER //
// src/components/templates/PageTemplate/index.jsx